import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

export const Row = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;

  padding: 19px 0 15px 0;
  
  h2 {
    font-family: "Grifter", "Open Sans", sans-serif;
    color: #6B49F6;
    align-self: center;
    justify-self: center;
    width: 100%;
    height: 100%;
    text-align: center;
  }

  > a {
    font-size: 18px;
    text-decoration: none;
    color: var(--color-blue);
    padding: 5px 0 -25px 0;

    & + a {
      padding-left: 10px;
      margin-left: 10px;
      border-left: 1px solid var(--color-border);
    }

    &.last-child-to-row {
      color: var(--color-gray);
    }
  }
`;

export const Panel = styled.div`
  background: var(--color-white);
  box-shadow: var(--panel-shadow);

  display: grid;


  @media only screen and (min-width: 1000px) {
    grid-template-columns: 65fr 35fr;
  }
`;

export const Column = styled.div`
  &.product-column {
    position: relative;
  }
  &:first-child {
    border-right: 1px solid var(--color-border);
  }
  &.opacity-invisible {
    position: relative;
    h1, h2, h3, h4, h5, h6 {
      color: #EAEAF0;
      -webkit-touch-callout: none; /* iOS Safari */
      -webkit-user-select: none; /* Safari */
      -khtml-user-select: none; /* Konqueror HTML */
      -moz-user-select: none; /* Old versions of Firefox */
      -ms-user-select: none; /* Internet Explorer/Edge */
      user-select: none;
      position: absolute;
      left: -2500px;
    }
  }
`;

export const Gallery = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 530px;

  picture {
    height: 100%;
    img {
      height: 95%;
    }
  }
  
  img {
    height: 73%;
  }
  
  .img_404_not_found {
    @media only screen and (min-width: 1000px) {
      width: 500px;
    }
    @media only screen and (max-width: 520px) {
      width: 100%;
      height: 50%;
    }
  }
`;

export const Section = styled.div`
  border-top: 1px solid var(--color-border);
  padding: 48px 32px;

  display: flex;
  flex-direction: column;

  > h4 {
    font-size: 18px;
    margin-bottom: 40px;
  }

  > div {
    display: flex;
    flex-direction: column;

    > span + span {
      margin-top: 16px;
    }

    .title {
      font-size: 16px;
      color: var(--color-black);
    }

    .description {
      margin-top: 5px;
      font-size: 14px;
      color: var(--color-gray);
      line-height: 19px;
    }
  }

  > a {
    margin-top: 20px;
    font-size: 14px;
    font-weight: 600;
    color: var(--color-blue);
    text-decoration: none;
  }
`;

export const Description = styled.div`
  border-top: 1px solid var(--color-border);
  padding: 44px 32px;

  > h2 {
    font-size: 24px;
    margin-bottom: 20px;
  }

  > p {
    font-size: 20px;
    color: var(--color-gray);
    line-height: 27px;
  }
`;
